<template>
    <v-dialog
        v-model="dialogUploadLiveClass"
        persistent
        scrollable
        max-width="1050"
    >
        <v-card>
            <v-toolbar flat>
                <v-toolbar-title class="font-weight-500"
                    >Upload Live Class</v-toolbar-title
                >

                <v-spacer></v-spacer>

                <v-btn small icon class="mr-2" @click="closeDialog()">
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </v-toolbar>

            <v-card-text style="height: 800px">
                <template>
                    <transition name="carousel">
                        <div v-if="page_upload === 'list'">
                            <div class="px-2 pt-10 pb-7">
                                <v-row>
                                    <v-col cols="9">
                                        <v-text-field
                                            v-model="search"
                                            append-icon="mdi-magnify"
                                            placeholder="Cari Gambar"
                                            outlined
                                            hide-details
                                        ></v-text-field>
                                    </v-col>

                                    <v-col
                                        cols="3"
                                        class="d-flex align-center"
                                        style="gap: 15px"
                                    >
                                        <v-btn-toggle
                                            v-model="toggle_exclusive"
                                            mandatory
                                        >
                                            <v-btn @click="mode_view = 'image'">
                                                <v-icon
                                                    >mdi-image-outline</v-icon
                                                >
                                            </v-btn>
                                            <v-btn @click="mode_view = 'list'">
                                                <v-icon
                                                    >mdi-view-list-outline</v-icon
                                                >
                                            </v-btn>
                                        </v-btn-toggle>

                                        <v-btn
                                            color="success"
                                            depressed
                                            dark
                                            large
                                            @click="page_upload = 'add'"
                                        >
                                            <v-icon class="mr-1"
                                                >mdi-plus</v-icon
                                            >
                                            Upload
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </div>

                            <div class="px-2" :hidden="mode_view === 'image'">
                                <template>
                                    <v-data-table
                                        :headers="headers"
                                        :items="thumbnails"
                                        :search="search"
                                        :loading="isLoadingImage"
                                        loading-text="Mengambil data gambar.."
                                        no-data-text="Gambar tidak tersedia"
                                        no-results-text="Gambar tidak ditemukan"
                                        :footer-props="{
                                            'items-per-page-options': [10, 25],
                                        }"
                                    >
                                        <template v-slot:item.action="{ item }">
                                            <v-btn
                                                depressed
                                                small
                                                class="white--text"
                                                color="blew"
                                                @click="
                                                    $emit('selected', item.url)
                                                "
                                            >
                                                Pilih
                                            </v-btn>

                                            <v-btn
                                                depressed
                                                small
                                                class="white--text ml-1"
                                                color="primary"
                                                @click="openUrl(item.url)"
                                            >
                                                Buka
                                            </v-btn>
                                        </template>
                                    </v-data-table>
                                </template>
                            </div>

                            <div :hidden="mode_view === 'list'" class="mt-7">
                                <div
                                    v-if="isLoadingImage"
                                    class="mt-10"
                                    align="center"
                                >
                                    <v-progress-circular
                                        :width="4"
                                        :size="35"
                                        color="blew"
                                        indeterminate
                                    ></v-progress-circular>
                                </div>

                                <v-row class="px-1">
                                    <v-col
                                        v-for="(file, index) in img_upload"
                                        sm="3"
                                        cols="3"
                                        class="pb-8"
                                        :key="index"
                                    >
                                        <v-card
                                            class="mx-auto mb-6 fullheight"
                                            outlined
                                            max-width="400"
                                        >
                                            <v-img
                                                :src="file.url"
                                                class="img-fluid"
                                                :title="'file' + index"
                                                height="150px"
                                            >
                                            </v-img>

                                            <v-card-text>
                                                <div
                                                    class="font-weight-bold pb-3"
                                                >
                                                    {{ file.name }}
                                                </div>
                                            </v-card-text>

                                            <v-card-actions
                                                style="
                                                    position: absolute;
                                                    bottom: 0;
                                                    width: 100%;
                                                "
                                            >
                                                <v-btn
                                                    depressed
                                                    small
                                                    block
                                                    class="white--text"
                                                    color="blew"
                                                    @click="
                                                        $emit(
                                                            'selected',
                                                            file.url,
                                                        )
                                                    "
                                                >
                                                    Pilih Gambar
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-col>

                                    <v-col
                                        v-if="
                                            !isLoadingImage &&
                                            !img_upload.length
                                        "
                                        cols="12"
                                    >
                                        <div class="text-center mt-10">
                                            Gambar tidak ditemukan..
                                        </div>
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </transition>
                </template>

                <template>
                    <transition name="carousel">
                        <div v-if="page_upload === 'add'">
                            <v-card flat>
                                <v-card-text class="px-2">
                                    <div class="mt-5 mb-4">
                                        <v-btn
                                            color="#ec675e"
                                            depressed
                                            dark
                                            @click="
                                                ((page_upload = 'list'),
                                                getImageUpload())
                                            "
                                        >
                                            <v-icon class="mr-1"
                                                >mdi-arrow-left</v-icon
                                            >
                                            Kembali
                                        </v-btn>
                                    </div>

                                    <div
                                        class="font-weight-bold pb-2 mt-5 mb-1 d-flex align-center"
                                        style="font-size: 16px"
                                    >
                                        {{
                                            !file_images.length
                                                ? "Pilih Gambar *"
                                                : "List Gambar"
                                        }}

                                        <v-menu
                                            v-if="!file_images.length"
                                            v-model="menu"
                                            :close-on-content-click="false"
                                            :nudge-width="200"
                                            :nudge-bottom="10"
                                            offset-y="500"
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <v-btn
                                                    color="#474958"
                                                    dark
                                                    icon
                                                    small
                                                    class="ml-1"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <v-icon
                                                        >mdi
                                                        mdi-information</v-icon
                                                    >
                                                </v-btn>
                                            </template>

                                            <v-card rounded>
                                                <v-card-text class="pa-3">
                                                    <div
                                                        class="font-weight-600 mb-2"
                                                    >
                                                        Petunjuk
                                                    </div>
                                                    <ol>
                                                        <li>
                                                            Maksimum ukuran file
                                                            300 KB
                                                        </li>
                                                        <li>
                                                            File gambar yang
                                                            diizinkan : png,
                                                            jpg, jpeg
                                                        </li>
                                                    </ol>
                                                </v-card-text>
                                            </v-card>
                                        </v-menu>
                                    </div>

                                    <v-row>
                                        <v-col cols="12" md="10">
                                            <!----Upload Container-------------------------------------------------------->
                                            <div
                                                v-if="!file_images.length"
                                                class="wrapper-custom-input mt-2"
                                            >
                                                <v-card
                                                    outlined
                                                    color="#f7f8fa"
                                                    style="
                                                        border: 2px #bdbdbd
                                                            dashed !important;
                                                    "
                                                >
                                                    <v-card-text class="py-6">
                                                        <div
                                                            class="d-flex align-center"
                                                            style="
                                                                gap: 10px;
                                                                justify-content: center;
                                                            "
                                                        >
                                                            <v-icon
                                                                color="#999999"
                                                                large
                                                            >
                                                                mdi
                                                                mdi-cloud-upload
                                                            </v-icon>

                                                            <span class="ml-3">
                                                                <p>
                                                                    Tarik dan
                                                                    letakkan
                                                                    atau
                                                                    <b
                                                                        class="text-primary"
                                                                        >Pilih
                                                                        Gambar</b
                                                                    >
                                                                    untuk unggah
                                                                    gambar live
                                                                    class
                                                                </p>
                                                                <p>
                                                                    Pastikan
                                                                    sesuai
                                                                    format png,
                                                                    jpg, jpeg
                                                                    yang
                                                                    disediakan
                                                                    dengan
                                                                    maksimal
                                                                    ukuran
                                                                    300kb.
                                                                </p>
                                                            </span>
                                                        </div>
                                                    </v-card-text>
                                                </v-card>

                                                <input
                                                    type="file"
                                                    multiple
                                                    accept="image/svg, image/jpg, image/png, image/jpeg"
                                                    class="custom-file-input"
                                                    @change="addFilesImages"
                                                />
                                            </div>
                                            <!----Upload Container-------------------------------------------------------->

                                            <!----Image List-------------------------------------------------------->
                                            <div v-if="file_images.length">
                                                <div
                                                    class="content-display pt-5"
                                                >
                                                    <v-row class="px-1">
                                                        <v-col
                                                            sm="4"
                                                            cols="4"
                                                            v-for="(
                                                                file, f
                                                            ) in file_images"
                                                            :key="f"
                                                        >
                                                            <v-card
                                                                class="mx-auto mb-6"
                                                                max-width="400"
                                                                outlined
                                                            >
                                                                <v-img
                                                                    :src="
                                                                        imageSources[
                                                                            f
                                                                        ]
                                                                    "
                                                                    class="img-fluid"
                                                                    :title="
                                                                        file.name
                                                                    "
                                                                    height="150px"
                                                                />

                                                                <v-card-text
                                                                    class="text--primary px-3"
                                                                >
                                                                    <div
                                                                        style="
                                                                            min-height: 50px;
                                                                        "
                                                                    >
                                                                        {{
                                                                            file.name
                                                                        }}
                                                                        <v-btn
                                                                            rounded
                                                                            depressed
                                                                            small
                                                                            class="ml-1"
                                                                        >
                                                                            {{
                                                                                (
                                                                                    file.size /
                                                                                    1000
                                                                                ).toFixed(
                                                                                    1,
                                                                                )
                                                                            }}
                                                                            KB
                                                                        </v-btn>
                                                                    </div>

                                                                    <v-btn
                                                                        outlined
                                                                        color="red"
                                                                        block
                                                                        class="mt-5"
                                                                        @click="
                                                                            removeImage(
                                                                                f,
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            small
                                                                            class="mr-1"
                                                                        >
                                                                            mdi-delete
                                                                        </v-icon>
                                                                        Hapus
                                                                    </v-btn>
                                                                </v-card-text>
                                                            </v-card>
                                                        </v-col>
                                                    </v-row>
                                                </div>
                                            </div>
                                            <!----Image List-------------------------------------------------------->
                                        </v-col>

                                        <v-col cols="12" md="2">
                                            <v-btn
                                                depressed
                                                large
                                                block
                                                class="white--text mt-2"
                                                color="#27ae60"
                                                :disabled="!file_images.length"
                                                :loading="isLoading"
                                                @click="uploadImage()"
                                            >
                                                <v-icon class="mr-1"
                                                    >mdi-plus</v-icon
                                                >
                                                Upload
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                        </div>
                    </transition>
                </template>
            </v-card-text>
        </v-card>

        <v-snackbar v-model="snackbar" top color="blew" timeout="1500">
            {{ snackbar_text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    color="white"
                    text
                    v-bind="attrs"
                    @click="snackbar = false"
                >
                    Tutup
                </v-btn>
            </template>
        </v-snackbar>
    </v-dialog>
</template>

<script>
import Spinner from "@/modules/global/components/plugins/Spinner";
import axios from "axios";
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import { read, utils } from "xlsx";

export default {
    name: "upload-image-liveclass",
    components: {
        "app-spinner": Spinner,
        "app-datatable": DataTable,
    },

    data: function () {
        return {
            tabs: null,
            isLoading: false,
            isLoadingImage: false,
            dialogUploadLiveClass: true,
            dialogCheckExcel: false,
            file_images: [],
            readers: [],
            file_excel: null,
            res_img: null,
            res_excel: null,
            img_upload: [],
            img_upload_ori: [],
            headers: [
                { text: "Nama", value: "name", width: "300" },
                { text: "URL", value: "url", width: "" },
                { text: "", value: "action", width: "180" },
            ],
            thumbnails: [],
            pagination: {
                perPage: 10,
                currentPage: 1,
                totalPages: 0,
                sortMode: "",
            },
            page_upload: "list",
            mode_view: "image",
            teachers: [],
            mapels: [],
            user_groups: [],
            imageSources: [],
            studentData: [],
            show_code: false,
            search: "",
            snackbar: false,
            snackbar_text: "URL berhasil dicopy",
        };
    },

    watch: {
        search(val) {
            if (val) {
                this.img_upload = this.img_upload_ori;
                this.img_upload = this.img_upload.filter(
                    (e) => e.name.includes(val) || e.url.includes(val),
                );
            } else {
                this.img_upload = this.img_upload_ori;
            }
        },
    },

    mounted() {
        this.getImageUpload();
    },

    methods: {
        closeDialog() {
            this.$emit("closeDialog");
        },

        addFilesImages(event) {
            const files = event.target.files;
            const context = this;

            const validExtensions = [
                "image/jpeg",
                "image/png",
                "image/svg+xml",
            ];
            context.file_images = [];
            context.imageSources = [];
            context.readers = [];

            Array.from(files).forEach((file, index) => {
                if (validExtensions.includes(file.type)) {
                    const reader = new FileReader();
                    context.readers.push(reader);

                    reader.onloadend = (e) => {
                        context.imageSources.push(reader.result);
                    };

                    reader.readAsDataURL(file);
                    context.file_images.push(file);
                } else {
                    context.$store.commit("showAlert", {
                        message: `Anda memasukan file gambar yang tidak valid`,
                        submessage: `pastikan file gambar anda bertipe png, jpg atau jpeg`,
                        type: "error",
                    });
                }
            });
        },

        async getImageUpload() {
            const context = this;
            context.isLoadingImage = true;
            context.thumbnails = [];
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            setTimeout(() => {
                try {
                    axios
                        .get(
                            `${process.env.API_BASE_URL}liveclass/admin/get-thumbnail`,
                            options,
                        )
                        .then((response) => {
                            context.img_upload = response.data.thumbnails;
                            context.img_upload_ori = response.data.thumbnails;

                            response.data.thumbnails.forEach(
                                function (data, index) {
                                    var row = {
                                        no: index,
                                        id: data.id,
                                        name: data.name,
                                        url: data.url,
                                    };
                                    context.thumbnails.push(row);
                                },
                            );

                            context.isLoadingImage = false;
                        });
                } catch (error) {
                    context.isLoadingImage = false;
                }
            }, 200);
        },

        uploadImage() {
            var context = this;
            var token = context.$ls.get("token");
            var url =
                process.env.API_BASE_URL + "liveclass/admin/upload-thumbnail";

            if (!context.file_images.length) {
                context.$store.commit("showAlert", {
                    message: `Pilih gambar terlebih dahulu`,
                    type: "error",
                });
                return false;
            }

            context.isLoading = true;

            var formData = new FormData();
            this.file_images.forEach((file) => {
                formData.append("file", file);
            });

            var param = formData;

            var http = axios.create({
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + token,
                },
            });

            http.post(url, param)
                .then(function (response) {
                    context.res_img = response.data.files;
                    context.file_images = [];

                    context.$store.commit("showAlert", {
                        message: `Proses upload berhasil, ${context.res_img.length} gambar berhasil diupload`,
                        type: "success",
                    });

                    context.isLoading = false;
                })
                .catch(function (error) {
                    context.$store.commit("showAlert", {
                        message: `Ukuran untuk 1 gambar upload maksimal 300 kb, periksa kembali gambar anda!`,
                        type: "error",
                    });
                    context.isLoading = false;
                });
        },

        copyUrl(url) {
            navigator.clipboard.writeText(url);
            this.snackbar = true;
        },

        openUrl(url) {
            window.open(url, "_blank");
        },

        removeImage(index) {
            this.file_images.splice(index, 1);
            this.imageSources.splice(index, 1);
        },
    },
};
</script>

<style>
/* .v-input__icon {
  margin: 10px 5px !important;
} */

.tab--text {
    text-decoration: none !important;
    text-transform: none !important;
    letter-spacing: normal;
    font-size: 15px;
}

.carousel-enter-active,
.carousel-leave-active {
    transition: transform 0.3s ease;
}
.carousel-enter, .carousel-leave-to /* .carousel-leave-active in <2.1.8 */ {
    transform: translateX(-100%);
}
.carousel-enter-to,
.carousel-leave {
    transform: translateX(0);
}

.wrapper-custom-input {
    position: relative;
    width: 100%;
}

.custom-file-input {
    width: 100%;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    opacity: 0;
    cursor: pointer;
    height: 100%;
    position: absolute;
}

.v-tooltip .v-tooltip__content {
    background-color: red !important; /* Ganti dengan warna yang diinginkan */
}

.fullheight {
    height: 100% !important;
}

.absolute {
    position: absolute;
}

.relative {
    position: relative !important;
}
</style>



// WEBPACK FOOTER //
// UploadImage.vue?75792e8b